import {EmptyScreen} from './styled';

type EmptyStateProps = {
  imageSrc: string;
  title: string;
  description: string;
};
function EmptyState({imageSrc, title, description}: EmptyStateProps) {
  return (
    <EmptyScreen className="empty-screen">
      <img src={imageSrc} width={200} height={200} alt="" className="empty-screen-img" />
      <h1 className="empty-screen__title">{title}</h1>
      <p className="empty-screen__description">{description}</p>
    </EmptyScreen>
  );
}

export {EmptyState};
